import { createContext, useState } from 'react';

const DictionaryContext = createContext();

export const DictionaryContextProvider = ({ children }) => {
    const [dictionaries, setDictionaries] = useState(null);

    const dict_floor = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "FLOOR").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))

    const dict_building = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "BUILDING").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))

    const dict_campus = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "CAMPUS").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))

    const dict_device_type = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "DEVICE_TYPE").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))
    const dict_encryption_type = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "ENCRYPTION_TYPE").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))
    const dict_lab = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "LAB").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))
    const dict_inventory_status = dictionaries === null ? [] :
        dictionaries.filter(de => de.system_name === "INVENTORY_STATUS").sort((a, b) => (a.dictionary_detail > b.dictionary_detail ? 1 : -1))
    const dict_attestion_status = dictionaries === null ? 'OFF' :
        dictionaries.filter(de => de.system_name === "ATTESTATION_STATUS")[0].dictionary_value
    const dict_certification_start_date = dictionaries === null ? '1900-01-01' : 
      dictionaries.filter(de => de.system_name ==="CERTIFICATION_START_DATE")[0].dictionary_value;
    const dict_status_to_hide = dictionaries === null ? [] : 
      dictionaries.filter(de => de.system_name ==="DEVICE_STATUS_TO_HIDE").map(d => d.dictionary_value);

    const setAllDictionaries = (all_dicts) => {
        // console.log("dictionaryContext - setting up dictionaries", all_dicts)
        setDictionaries(all_dicts);
    };

    const reset = () => {
        setDictionaries(null)
    }

    const set_attestation_status = (status) => {
        let all_dicts = [...dictionaries]
        const index = all_dicts.findIndex(de => de.system_name === "ATTESTATION_STATUS" && de.system_name === "ATTESTATION_STATUS")
        if (index >= 0) {
            all_dicts[index] = {...all_dicts[index], dictionary_value: status}
        }
        setDictionaries([...all_dicts])
    }

    return (
    <DictionaryContext.Provider
        value={{
        setAllDictionaries,
        dictionaries,
        dict_floor,
        dict_building,
        dict_campus,
        dict_device_type,
        dict_encryption_type,
        dict_lab,
        dict_inventory_status,
        dict_attestion_status,
        set_attestation_status,
        dict_certification_start_date,
        dict_status_to_hide,
        reset,
        }}
    >
        {children}
    </DictionaryContext.Provider>
    );
};

export default DictionaryContext;